const plates = require("./plates")
const deliveryPrices = require("./delivery-prices")
const { docs } = require("./docs")
const { testingCenters } = require("./testing-centers")
const { licenses } = require("./licenses")
const {
  comprehensiveInsurance,
} = require("../multi-city/comprehensive-insurance")
const { vehicleTracking } = require("../multi-city/vehicle-tracking")

const lagos = {
  city: "lagos",
  areas: [],
  plates,
  docs,
  licenses,
  testingCenters,
  deliveryPrices,
  comprehensiveInsurance,
  vehicleTracking,
}

module.exports = lagos
